import {
  AnalyticsPageTypeProperty,
  RbGtmClient,
} from '@redbubble/next-analytics/gtm';

export enum GACategory {
  Cart = 'Cart',
  CartMessage = 'Cart Messages',
  CheckoutFlow = 'CheckoutFlow',
}

export enum GAAction {
  CheckoutStartApplePay = 'CheckoutStart-ApplePay',
  CheckoutStartGooglePay = 'CheckoutStart-GooglePay',
  Click = 'click',
  Complete = 'Complete',
  CouponAutoApplied = 'CouponAutoApplied',
  CouponLoginButtonClicked = 'CouponLoginButtonClicked',
  CouponManuallyApplied = 'CouponManuallyApplied',
  CouponManuallyAppliedError = 'CouponManuallyAppliedError',
  CouponModalClosed = 'CouponModalClosed',
  CouponModalOpened = 'CouponModalOpened',
  CouponRemove = 'CouponRemove',
  CouponRemoved = 'CouponRemoved',
  CouponSignUpButtonClicked = 'CouponSignUpButtonClicked',
  InView = 'in-view',
  LineItemRemoved = 'ItemRemoved',
  PaymentAvailableApplePay = 'PaymentAvailable-ApplePay',
  PaymentAvailableGooglePay = 'PaymentAvailable-GooglePay',
  ProductAttributeSelected = 'ProductAttributeSelected',
  ShippingPreferenceChanged = 'Shipping Preference Changed',
}

export enum GALabel {
  ApplePay = 'ApplePay',
  Cart = 'Cart',
  GooglePay = 'GooglePay',
  Quantity = 'quantity',
}

export const trackGA4ViewPromotion = ({
  promotionName,
  creativeSlot,
}: {
  promotionName: string;
  creativeSlot: string;
}) => {
  RbGtmClient.track({
    event: 'view_promotion',
    page_location: window.location.toString(),
    ecommerce: {
      creative_slot: creativeSlot,
      promotion_name: promotionName,
    },
  });
};

export const trackGA4SelectShippingPreference = ({
  shippingPreference,
}: {
  shippingPreference: string;
}) => {
  RbGtmClient.track({
    event: 'select_shipping_preference',
    page_location: window.location.toString(),
    shipping_preference: shippingPreference,
  });
};

export const trackGA4AddGiftCardToCartEvent = ({
  giftCardAmount,
  currency,
  pageType,
}: {
  giftCardAmount: number;
  currency: string;
  pageType: AnalyticsPageTypeProperty;
}) => {
  RbGtmClient.track({
    event: 'add_to_cart',
    page_location: window.location.toString(),
    context: '',
    currency,
    page_type: pageType,
    ecommerce: {
      currency,
      value: giftCardAmount.toString(),
      items: [
        {
          work_id: null,
          product_type_id: '',
          blank_item_id: '',
          inventory_item_id: null,
          retargeting_id: null,
          item_id: `gift-certificate-${currency}-${giftCardAmount}`,
          item_list_id: null,
          item_list_name: null,
          discount: 0,
          index: null,
          price: giftCardAmount,
          quantity: 1,
        },
      ],
    },
    search_query_id: null,
  });
};
